module.exports = __webpack_public_path__ + "static/media/jdrManoir_03_thumb.86948f6d.png";